module.exports = __webpack_public_path__ + "media/fonts/Objectivity-Bold-74ecbb28be36b102c426eac146d35466.otf";